import React, { useEffect, useState } from 'react';

import PhoneCodeVerify from 'features/authentication/SignIn/PhoneVerification/PhoneCodeVerify';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

const PhoneVerification = ({ onError }: ErrorTrackingProps) => {
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    const phone = new URLSearchParams(window.location.search)?.get('phone');

    if (phone) {
      setPhoneNumber(phone);
    }
  }, []);

  return phoneNumber ? (
    <PhoneCodeVerify onError={onError} phone={phoneNumber} />
  ) : null;
};

export default PhoneVerification;
